import api from "./api";

export const guestLoginApi = () => {
    return api.post(`/api/users/`);
};

export const loginApi = async (credentials: { email: string; password: string }) => {
    return api.post(`/api/token/`, credentials);
};

export const registrationApi = (payload: {
    first_name: string;
    last_name?: string;
    age?:string;
    specialty?: string;
    credentials?:string;
    country?: string;
    npi?: string;
    is_doctor?: boolean;
    license?: string;
    license_state?: string;
}) => {
    return api.patch(`/api/users/update/`, payload);
};

export const sendOtpApi = (payload: { email: string }) => {
    return api.post(`/api/auth/otp/request/`, payload);
};

export const verifyOtpApi = (payload: { email: string; otp: string }) => {
    return api.post(`/api/auth/otp/verify/`, payload);
};

export const resendOtpApi = (payload: { email: string }) => {
    return api.post(`/api/auth/otp/request/`, payload);
};

export const feedbackApi = (payload: {
    star_rating: number | null;
    text_rating: string;
    abusive: boolean;
    biased: boolean;
    helpful: string;
    remarks: string;
    chat_id: number|string;
    feedback_form?: any;
}) => {
    return api.patch(`/api/chat-message/update/${payload.chat_id}/`, payload);
};

export const createChatSessionApi = (data?: { partner_project_id?: string; current_consultation_id?: string; latest_consultation_id?: string; total_consultation_count?: number }, signal?: AbortSignal) => {
    const payload: Record<string, string | number> = {};
    if (data?.partner_project_id) payload.partner_project_id = data.partner_project_id;
    if (data?.current_consultation_id) payload.current_consultation_id = data.current_consultation_id;
    if (data?.latest_consultation_id) payload.latest_consultation_id = data.latest_consultation_id;
    if (data?.total_consultation_count !== undefined) payload.total_consultation_count = data.total_consultation_count;
    return api.post(`/api/chatsessions/`, payload, {
        timeout: 20000,
        signal,
    });
};

export const fetchChatSessionsApi = (
    offset: number,
    limit: number,
    q?: string,
    partnerProjectId?: string
  ) => {
    return api.get('/api/chatsessions/', {
      params: {
        offset,
        limit,
        q,
        ...(partnerProjectId ? { partner_project_id: partnerProjectId } : {}),
      },
    });
  };

export const fetchChatMessagesApi = (payload: { session_id: number | string}) => {
    return api.get(`/api/session-messages/?session_id=${payload.session_id}`);
};

export const fetchUserProfileApi = () => {
    return api.get(`/api/users/profile/`);
};

export const deleteAllChat = () => {
    return api.delete(`/api/chat-message/delete-all/`);
};

export const deleteAccount = () => {
    return api.delete(`/api/users/delete-profile/`);
};

export const deleteChatSessionApi = (sessionId: number |string) => {
    return api.delete(`/api/chatsessions/${sessionId}/`);
  };

export const updateTiteSession = (payload: {
    id: string;              // header parameter
    body: {
      header: string;
    };
  }) => {
    return api.patch(`/api/chatsessions/${payload.id}/`, payload.body);
  };

  export const createBookmarkApi = (data: {
    title: string;
    session_id?: string;
    message_id: string;
  }) => {
    return api.post('/api/bookmarks/', data);
  };

  export const fetchBookmarksApi = (
    offset: number,
    limit: number,
    q?: string
  ) => {
    return api.get('/api/bookmarks/', {
      params: {
        offset,
        limit,
        q,
      },
    });
  };

  export const deleteBookmarkApi = (bookmarkId:string) => {
    return api.delete(`/api/bookmarks/${bookmarkId}/`);
  };

  export const patchBookmarkApi = (payload: {bookmarkId: string;
    title: string;}) => {
    return api.patch(
      `/api/bookmarks/${payload.bookmarkId}/`,
      {
        title: payload.title,
      }
    );
  };

  export const updateConsentApi = (
    payload: {
        slug: string;
        status: string;
    }
) => {
    return api.post(
        "/api/consents/",
        payload
    );
};
